import * as contants from './constants';
import http from '../../../utils/request';
// import axios from 'axios';

const getTechData = (result) => ({
  type: contants.GET_TECH_DATA,
  cardList: result.list,
  head: result.head
})

export const fetchTechData = () => {
  return (dispatch) => {
    http('post','/achieve/demand/service').then((res) => {
      const result = res.data;
      dispatch(getTechData(result))
    })
  }
}